module.exports = __webpack_public_path__ + "static/media/Adhaar_Sample.677a39b8.png";